
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Check } from "lucide-react";

const AccountCreated = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      navigate("/account");
    }
  }, [user, navigate]);

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-md mx-auto text-center">
        <div className="rounded-full bg-green-100 w-16 h-16 mx-auto mb-6 flex items-center justify-center">
          <Check className="w-8 h-8 text-green-600" />
        </div>
        
        <h1 className="text-3xl font-bold tracking-tight mb-4">
          Compte créé avec succès !
        </h1>
        
        <p className="text-gray-600 mb-8">
          Merci de vous être inscrit. Votre compte a été créé avec succès et vous êtes maintenant connecté.
        </p>

        <div className="space-y-4">
          <Button 
            onClick={() => navigate("/")}
            size="lg"
            className="w-full"
          >
            Découvrir la boutique
          </Button>
          
          <Button 
            onClick={() => navigate("/account")}
            variant="outline"
            size="lg"
            className="w-full"
          >
            Compléter mon profil
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountCreated;
